import Adv from './ad'
export default Adv
